var _defs, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3b2100120f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.972656 5.542969 L 358.222656 5.542969 L 358.222656 369.292969 L 31.972656 369.292969 Z M 31.972656 5.542969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b2100120f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3fbfbb",
    d: "M 358.210938 168.582031 C 358.210938 78.5625 285.1875 5.589844 195.101562 5.589844 C 105.011719 5.589844 31.980469 78.5625 31.980469 168.582031 C 31.980469 258.605469 105.011719 331.578125 195.101562 331.578125 C 202.914062 331.578125 210.585938 331.015625 218.109375 329.960938 L 259.601562 369.246094 L 259.601562 318.335938 C 317.601562 293.355469 358.210938 235.707031 358.210938 168.582031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 74.679688 163 C 74.679688 147.359375 85.539062 135.648438 100.742188 135.648438 C 115.957031 135.648438 126.378906 146.9375 126.378906 163 C 126.378906 178.625 115.957031 190.34375 99.882812 190.34375 C 85.117188 190.34375 74.679688 178.625 74.679688 163 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 164.648438 163 C 164.648438 147.359375 175.511719 135.648438 190.714844 135.648438 C 205.929688 135.648438 216.347656 146.9375 216.347656 163 C 216.347656 178.625 205.929688 190.34375 189.851562 190.34375 C 175.082031 190.34375 164.648438 178.625 164.648438 163 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 254.613281 163 C 254.613281 147.359375 265.476562 135.648438 280.6875 135.648438 C 295.894531 135.648438 306.3125 146.9375 306.3125 163 C 306.3125 178.625 295.894531 190.34375 279.824219 190.34375 C 265.050781 190.34375 254.613281 178.625 254.613281 163 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.70b91126234b33e9517e0704f229e8db.svg";
export { ForwardRef as ReactComponent };